import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-vaisseau',
  templateUrl: './vaisseau.component.html',
  styleUrls: ['./vaisseau.component.css']
})
export class VaisseauComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
